import { render } from "./TechSupportCard.vue?vue&type=template&id=fab8107a&scoped=true"
import script from "./TechSupportCard.vue?vue&type=script&lang=js"
export * from "./TechSupportCard.vue?vue&type=script&lang=js"

import "./TechSupportCard.vue?vue&type=style&index=0&id=fab8107a&lang=scss"
import "./TechSupportCard.vue?vue&type=style&index=1&id=fab8107a&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab8107a"]])

export default __exports__